import { render, staticRenderFns } from "./form-group.vue?vue&type=template&id=6a4c71f4&"
import script from "./form-group.vue?vue&type=script&lang=ts&"
export * from "./form-group.vue?vue&type=script&lang=ts&"
import style0 from "./form-group.vue?vue&type=style&index=0&id=6a4c71f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports